import { readonly } from 'vue'
import type { IPartners } from '~/gateway/partners/partners.types'
import { PartnersGateway } from '~/gateway/partners'
import type { IUsers } from '~/gateway/users/users.types'

export const usePartners = <R extends IUsers.Role>() => {
  const state = useState<IPartners.Model<R>[]>('partners', () => [])

  const fetch = async () => {
    const res = await PartnersGateway.getMany<R>({})

    if (res) {
      state.value = res.list
    }
  }

  const patch = (updatedPartner: IPartners.Model<R>) => {
    const index = state.value.findIndex(partner => partner._id === updatedPartner._id)

    if (index) {
      state.value[index] = updatedPartner
    }
  }

  const actions = {
    fetch,
    patch,
  }

  return {
    actions,
    state: readonly(state),
  }
}
